// Hook custom per ricevere tutte le tipologie degli immobili pubblicati dall' agenzia.
// Nota: uso axios e TypeScript per tipizzare la risposta, gestire errori, loading e refetch.
import { useState, useCallback } from 'react';
import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_APP_API_BASE_URL;

// Tipizzazione Parametri dell'hook
interface hookParams {
    agencyId: number;       // ID dell'agenzia
    enabled?: boolean;      // se abilitare la chiamata (utile per componenti condizionali)
}

interface AgencyTypology {
    id: number;
    tipologia: string;
}

// Tipizzazione Risultato dell'hook
interface useGetAgencyTypologiesResult {
    typologies: AgencyTypology[] | null;
    loading: boolean;
    error: string | null;
    getAgencyTypologies: () => Promise<void>;
}
/**
 * usegetAgencyTypologies
 * @param agencyId - ID dell'agenzia
 * @returns - Array con tutte le tipologie degli immobili pubblicati dall'agenzia
*/

const useGetAgencyTypologies = ({
    agencyId,
    enabled = false
}: hookParams): useGetAgencyTypologiesResult => {
    const [typologies, setTypologies] = useState<AgencyTypology[] | null>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    const getAgencyTypologies = useCallback(async () => {
        if (!enabled) return;
        try {
            const response = await axios.post<AgencyTypology[]>(`${API_BASE_URL}/agency-typologies`, { agencyId });
            setTypologies(response.data);
            setError(null);
        } catch (err: unknown) {
            if (axios.isAxiosError(err)) {
                setError(err.response?.data?.error || err.message);
            } else if (err instanceof Error) {
                setError(err.message);
            } else {
                setError("Errore sconosciuto");
            }
        } finally {
            setLoading(false);
        }
    }, [agencyId, enabled]);

    return { typologies, loading, error, getAgencyTypologies };
};

export default useGetAgencyTypologies;